import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  ImageInput,
  ImageField,
  SelectInput,
  required,
  maxLength,
} from "react-admin";

const pageChoices = [
  { id: "sellers", name: "Distribuidores" },
  { id: "service", name: "Servicio técnico" },
  { id: "blog", name: "Blog" },
  { id: "contact", name: "Contacto" },
];

const BannerTitle = ({ record }) => {
  return <span>Banner {record ? `"${record.name}"` : ""}</span>;
};

export const BannerEdit = (props) => (
  <Edit
    title={<BannerTitle />}
    {...props}
    transform={(data) => {
      // Función para limpiar valores individuales
      const cleanValue = (value) => {
        if (!value) return null;
        if (value.rawFile instanceof File) return value;
        if (typeof value === "string") return { src: value };
        return value;
      };

      // Asegurarnos que los campos de texto sean string vacío en lugar de null
      const ensureString = (value) => {
        if (value === null || value === undefined) return "";
        return value;
      };

      return {
        ...data,
        name: ensureString(data.name),
        link: ensureString(data.link),
        page: ensureString(data.page),
        image: cleanValue(data.image),
      };
    }}
  >
    <SimpleForm redirect="list">
      <TextInput source="id" disabled />
      <TextInput
        source="name"
        label="Nombre"
        validate={[required(), maxLength(200)]}
      />
      <TextInput
        source="link"
        label="URL de destino"
        validate={[maxLength(200)]}
      />
      <SelectInput
        source="page"
        label="Página"
        choices={pageChoices}
        validate={[required()]}
      />
      <ImageInput
        source="image"
        label="Imagen"
        accept={{
          "image/*": [".png", ".jpg", ".jpeg", ".gif"],
        }}
        placeholder="Haz clic aquí o arrastra y suelta la imagen"
        validate={[required()]}
        options={{
          preventDropOnDocument: true,
          validator: (file) => {
            if (!file.type.startsWith("image/")) {
              return {
                code: "invalid-file-type",
                message: "Solo se permiten imágenes",
              };
            }
            return null;
          },
        }}
        format={(value) => {
          if (typeof value === "string" && value !== "") {
            return { src: value };
          }
          return value;
        }}
      >
        <ImageField source="src" title="title" />
      </ImageInput>
      <BooleanInput source="active" label="Activo" />
    </SimpleForm>
  </Edit>
);
